module.exports = __webpack_public_path__ + "img/grasshopper.4d55981f.jpg";